<div class="assignment-list-container" *ngIf="!loading">
  <!-- <div class="assignment-search">
    <input class="form-control" type="text" name="search" [(ngModel)]="searchText" autocomplete="off" itext="&#61442;  Free text search">
  </div> -->
  <div class="assignment-list" *ngFor="let assignment of assignments">
    <app-assignment [assignment]="assignment"></app-assignment>
  </div>
</div>
